<template >
  <ModeSwitchBar
    v-if="isManagerMode"
    @managerMode="managerMode = $event"
  ></ModeSwitchBar>
  <transition name="zoom">
    <div v-if="themeInfo.template" :class="[themeInfo?.template, managerMode]">
      <div class="theme-flag-div"><div class="theme-flag"></div></div>

      <div v-if="decodeURI($route.path) == '/' + $route.params.token">
        <videoBanner
          :videoObj="themeInfo.info?.videoBanners?.homePageBanner"
          :displayStyle="'homePageBanner'"
          v-if="themeInfo.info?.videoBanners?.homePageBanner"
        />
        <bannerImageSlider v-else />
      </div>
      <Header :small="false" v-else></Header>
      <div class="page-container">
        <router-view></router-view>
      </div>
      <BottomNavigation
        :theme="themeInfo?.template"
        @isManagerMode="isManagerMode = $event"
      />
    </div>

    <!-- <div v-if="themeInfo.template" :class="[styleName]">
      <div class="theme-flag-div"><div class="theme-flag"></div></div>
      <bannerImageSlider
        v-if="decodeURI($route.path) == '/' + $route.params.token"
      ></bannerImageSlider>
      <Header :small="false" v-else></Header>
      <div class="page-container">
        <router-view></router-view>
      </div>
      <BottomNavigation :theme="styleName"></BottomNavigation>
    </div> -->

    <loadingPage v-else></loadingPage>
  </transition>
</template>

<script>
import { computed } from "vue";
import Header from "@/components/header/index.vue";
import bannerImageSlider from "@/components/bannerImageSlider/index.vue";
import videoBanner from "@/components/videoBanner/index.vue";
import BottomNavigation from "@/components/BottomNavigation/index.vue";
import { bannersData } from "@/repo/bannersData.js";
import loadingPage from "@/components/loading/index.vue";
import ModeSwitchBar from "@/components/modeSwitchBar/index.vue";
import { mapGetters } from "vuex";
import { nextTick } from "@vue/runtime-core";
export default {
  name: "App",
  mixins: [bannersData],
  components: {
    loadingPage,
    Header,
    BottomNavigation,
    bannerImageSlider,
    videoBanner,
    ModeSwitchBar,
  },
  data() {
    return {
      myCss: `green`,
      isManagerMode: false,
    };
  },
  watch: {
    baseInfo: {
      handler(newVal) {
        console.log(newVal);
      },
      immediate: true,
      deep: true,
    },
    themeInfo: {
      handler(newVal) {
        console.log(newVal);
        //this.setBodyColor();
        this.customBuiltStyle();
        this.checkUrl();
        this.translate();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  methods: {
    translate() {
      setTimeout(() => {
        new google.translate.TranslateElement(
          {
            pageLanguage: "fa",
            includedLanguages: "fa,en,it,fr,ru,tr,ar",
            autoDisplay: false,
            layout: google.translate?.TranslateElement?.InlineLayout.SIMPLE,
          },
          "google_translate_element"
        );
      }, 2000);
    },
    checkUrl() {
      if (this.themeInfo?.info?.url != null) {
        if (
          window.location.hostname == "https://faliznet.ir" ||
          window.location.hostname == "faliznet.ir" ||
          window.location.hostname == "localhost"
        ) {
          // location.replace(this.themeInfo?.info?.url);
          window.location.href = 'home.php';
        }
      }
    },
    setBodyColor() {
      console.log("setBodyColor");
      console.log(this.themeInfo?.customerColors?.body_color);
      document.body.parentElement.style.backgroundColor =
        this.themeInfo?.customerColors?.body_color;
    },
    show() {
      console.log(this.$router);
    },
    getAllData(token) {
      // if (this.themeInfo && this.themeInfo.token != token) {
      this.$store.dispatch("theme/getAllData", {
        payload: {
          token: token,
        },
      });
      // }
    },
    customBuiltStyle() {
      if (this.themeInfo?.customStyleCss) {
        let css, head, style;
        head = document.head || document.getElementsByTagName("head")[0];
        style = document.createElement("style");
        head.appendChild(style);
        let myCustomStyleCss = "";
        myCustomStyleCss = this.themeInfo?.customStyleCss?.replace(
          /Xstyle/gi,
          this.themeInfo?.template
        );
        console.log("CSS =====> " + myCustomStyleCss);
        css = myCustomStyleCss ?? "";
        style.type = "text/css";
        style.id = "customBuiltStyle";
        if (style.styleSheet) {
          // This is required for IE8 and below.
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
      }
    },
    getData() {
      if (this.$route.params.token) {
        this.token = this.$route.params.token;
        this.$store.dispatch("base/getAllData").then((res) => {
          console.log(res);
        });
        this.getAllData(this.token);
        localStorage.setItem(
          "routeStorage",
          JSON.stringify({
            BusinessToken: this.$route.params.token ?? null,
            lastUserRoute: null,
          })
        );
      } else {
        this.$router.push("/");
      }
    },
  },
  computed: {
    baseInfo() {
      return this.$store.getters["base/base"];
    },
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      managerMode: "managerMode",
    }),
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/public-style/public-style.css);
</style>
<style lang="css">
@import url(@/assets/style/customerStyle/customerStyle.css);
</style>
<style lang="css">
@import url(@/assets/style/public-style/edit-data-mode.css);
</style>
